/**
 * Archetype determination client.
 */
import axios from "axios";
import { API_BASE_URL } from "../config";

/** Risk-tier chip colours (LOW / MEDIUM / HIGH / CRITICAL). */
export const RISK_TIER_COLORS = {
  LOW: { bg: "#ECFDF3", color: "#067647" },
  MEDIUM: { bg: "#FEF3C7", color: "#B45309" },
  HIGH: { bg: "#FFEDD5", color: "#C2410C" },
  CRITICAL: { bg: "#FEE2E2", color: "#B91C1C" },
};

/**
 * POST → classify the AUT (POC taxonomy) from its app summary.
 * Returns { success, data: { archetype: {
 *   predictedArchetype, baseCode, baseType, riskTier, archetypeDescription,
 *   riskDescription, confidence, recommendations[], keyFocusAreas[] } } }
 */
export async function determineArchetype(projectId) {
  const res = await axios.post(`${API_BASE_URL}/projects/${projectId}/archetype/determine`);
  return res.data;
}
